import { useEffect, useMemo } from "react";
import { desktop } from "@/desktop/bridge";
import { PROVIDER_PLUGIN, useAiProviders } from "@/desktop/chat";
import type { AiProvider } from "@/desktop/ui";
import { useActivePlugins } from "./use-plugins";

/** Mantém `useAiProviders` em dia com os plugins da conta (montado uma vez, na raiz). */
export function useSyncAiProviders() {
  const active = useActivePlugins();
  const installed = useMemo(
    () =>
      (Object.keys(PROVIDER_PLUGIN) as AiProvider[]).filter(
        (p) => active.some((a) => a.id === PROVIDER_PLUGIN[p]) && (p !== "copilot" || desktop !== null),
      ),
    [active],
  );
  useEffect(() => useAiProviders.setState({ installed }), [installed]);
}
